import { render, staticRenderFns } from "./CurrencyToggle.vue?vue&type=template&id=2eaba55c&scoped=true"
import script from "./CurrencyToggle.vue?vue&type=script&lang=js"
export * from "./CurrencyToggle.vue?vue&type=script&lang=js"
import style0 from "./CurrencyToggle.vue?vue&type=style&index=0&id=2eaba55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaba55c",
  null
  
)

export default component.exports